import { crud, http } from '../../../libs/react-mpk/services';

let service = new crud('/api/notification');

export const updateNotificationBulk = (query) => {
    return http.get(`/api/notification/bulk`, query);
};
export default service